export class FiltrSzukaj {
    wartoscSzukaj: string;
}